<template>
  <div>
    <panel title="Ustawienia">
      <w-table
        entity-type="setting"
        :hide-add-button="true"
        :columns="columns"
        :data="list"
        :actions="actions"
        :total="count"
        @edit="goToEdit($event.id)"
      />
    </panel>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import WTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { EDIT_ACTION } from '@/utils/constants';

const messages = {
  listError: 'Wystąpił błąd podczas pobierania ustawień.',
  getError: 'Wystąpił błąd podczas pobierania danych ustawienia.',
  added: 'Dodano ustawienie.',
  addError: 'Nie udało się dodać ustawienia.',
  updated: 'Zaktualizowano dane ustawienia.',
  updateError: 'Nie udało się zaktualizować danych ustawienia.',
  deleteConfirm: 'Czy na pewno chcesz usunąć ustawienie?',
  deleted: 'Usunięto ustawienie.',
  deleteError: 'Nie udało się usunąć ustawienia.'
};

// @vuese
// Lista ustawień
// @group setting
export default {
  components: { Panel, WTable },
  mixins: [listMixin('setting', messages)],
  data: () => ({
    columns: [
      { name: 'id', displayName: 'ID' },
      { name: 'code', displayName: 'Kod ustawienia', sortable: true },
      { name: 'description', displayName: 'Opis' },
      { name: 'entityType', displayName: 'Nazwa encji' },
      { name: 'entityId', displayName: 'Identyfikator encji' }
    ]
  }),
  computed: {
    actions() {
      return [{ ...EDIT_ACTION, permissions: ['SETTING.UPDATE'] }];
    }
  },
  methods: {
    // @vuese
    // Pokaż szczegóły
    goToEdit(id) {
      this.$router.push({ name: 'settingEdit', params: { settingId: id } });
    }
  }
};
</script>
